/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicInviteRouteImport } from './routes/_public/invite'
import { Route as PublicAuthSuccessRouteImport } from './routes/_public/auth-success'
import { Route as AuthenticatedSupportRouteImport } from './routes/_authenticated/support'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as PublicInviteIndexRouteImport } from './routes/_public/invite.index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings.index'
import { Route as PublicSigninOtpRouteImport } from './routes/_public/signin.otp'
import { Route as PublicSigninEmailRouteImport } from './routes/_public/signin.email'
import { Route as PublicOauthCallbackRouteImport } from './routes/_public/oauth.callback'
import { Route as PublicInviteOtpRouteImport } from './routes/_public/invite.otp'
import { Route as PublicInviteEmailRouteImport } from './routes/_public/invite.email'
import { Route as PublicInviteAuthRouteImport } from './routes/_public/invite.auth'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings.profile'
import { Route as AuthenticatedSettingsEmailRouteImport } from './routes/_authenticated/settings.email'
import { Route as AuthenticatedSettingsAddressRouteImport } from './routes/_authenticated/settings.address'
import { Route as AuthenticatedCampaignIdRouteImport } from './routes/_authenticated/campaign.$id'
import { Route as AuthenticatedSettingsConnectIndexRouteImport } from './routes/_authenticated/settings.connect.index'
import { Route as AuthenticatedCampaignIdIndexRouteImport } from './routes/_authenticated/campaign.$id.index'
import { Route as AuthenticatedCampaignIdTasksRouteImport } from './routes/_authenticated/campaign.$id.tasks'
import { Route as AuthenticatedCampaignIdSelectProductRouteImport } from './routes/_authenticated/campaign.$id.select-product'
import { Route as AuthenticatedCampaignIdConnectRouteImport } from './routes/_authenticated/campaign.$id.connect'
import { Route as AuthenticatedCampaignIdAddressEditRouteImport } from './routes/_authenticated/campaign.$id.address-edit'
import { Route as AuthenticatedCampaignIdAddressRouteImport } from './routes/_authenticated/campaign.$id.address'
import { Route as AuthenticatedCampaignIdAcceptedRouteImport } from './routes/_authenticated/campaign.$id.accepted'
import { Route as AuthenticatedCampaignIdTasksTaskIdRouteImport } from './routes/_authenticated/campaign.$id.tasks_.$taskId'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicInviteRoute = PublicInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthSuccessRoute = PublicAuthSuccessRouteImport.update({
  id: '/auth-success',
  path: '/auth-success',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicInviteIndexRoute = PublicInviteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicInviteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const PublicSigninOtpRoute = PublicSigninOtpRouteImport.update({
  id: '/signin/otp',
  path: '/signin/otp',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSigninEmailRoute = PublicSigninEmailRouteImport.update({
  id: '/signin/email',
  path: '/signin/email',
  getParentRoute: () => PublicRoute,
} as any)
const PublicOauthCallbackRoute = PublicOauthCallbackRouteImport.update({
  id: '/oauth/callback',
  path: '/oauth/callback',
  getParentRoute: () => PublicRoute,
} as any)
const PublicInviteOtpRoute = PublicInviteOtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => PublicInviteRoute,
} as any)
const PublicInviteEmailRoute = PublicInviteEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => PublicInviteRoute,
} as any)
const PublicInviteAuthRoute = PublicInviteAuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => PublicInviteRoute,
} as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsEmailRoute =
  AuthenticatedSettingsEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAddressRoute =
  AuthenticatedSettingsAddressRouteImport.update({
    id: '/address',
    path: '/address',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedCampaignIdRoute = AuthenticatedCampaignIdRouteImport.update({
  id: '/campaign/$id',
  path: '/campaign/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsConnectIndexRoute =
  AuthenticatedSettingsConnectIndexRouteImport.update({
    id: '/connect/',
    path: '/connect/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedCampaignIdIndexRoute =
  AuthenticatedCampaignIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCampaignIdRoute,
  } as any)
const AuthenticatedCampaignIdTasksRoute =
  AuthenticatedCampaignIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedCampaignIdRoute,
  } as any)
const AuthenticatedCampaignIdSelectProductRoute =
  AuthenticatedCampaignIdSelectProductRouteImport.update({
    id: '/select-product',
    path: '/select-product',
    getParentRoute: () => AuthenticatedCampaignIdRoute,
  } as any)
const AuthenticatedCampaignIdConnectRoute =
  AuthenticatedCampaignIdConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => AuthenticatedCampaignIdRoute,
  } as any)
const AuthenticatedCampaignIdAddressEditRoute =
  AuthenticatedCampaignIdAddressEditRouteImport.update({
    id: '/address-edit',
    path: '/address-edit',
    getParentRoute: () => AuthenticatedCampaignIdRoute,
  } as any)
const AuthenticatedCampaignIdAddressRoute =
  AuthenticatedCampaignIdAddressRouteImport.update({
    id: '/address',
    path: '/address',
    getParentRoute: () => AuthenticatedCampaignIdRoute,
  } as any)
const AuthenticatedCampaignIdAcceptedRoute =
  AuthenticatedCampaignIdAcceptedRouteImport.update({
    id: '/accepted',
    path: '/accepted',
    getParentRoute: () => AuthenticatedCampaignIdRoute,
  } as any)
const AuthenticatedCampaignIdTasksTaskIdRoute =
  AuthenticatedCampaignIdTasksTaskIdRouteImport.update({
    id: '/tasks_/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AuthenticatedCampaignIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/support': typeof AuthenticatedSupportRoute
  '/auth-success': typeof PublicAuthSuccessRoute
  '/invite': typeof PublicInviteRouteWithChildren
  '/campaign/$id': typeof AuthenticatedCampaignIdRouteWithChildren
  '/settings/address': typeof AuthenticatedSettingsAddressRoute
  '/settings/email': typeof AuthenticatedSettingsEmailRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/invite/auth': typeof PublicInviteAuthRoute
  '/invite/email': typeof PublicInviteEmailRoute
  '/invite/otp': typeof PublicInviteOtpRoute
  '/oauth/callback': typeof PublicOauthCallbackRoute
  '/signin/email': typeof PublicSigninEmailRoute
  '/signin/otp': typeof PublicSigninOtpRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/invite/': typeof PublicInviteIndexRoute
  '/campaign/$id/accepted': typeof AuthenticatedCampaignIdAcceptedRoute
  '/campaign/$id/address': typeof AuthenticatedCampaignIdAddressRoute
  '/campaign/$id/address-edit': typeof AuthenticatedCampaignIdAddressEditRoute
  '/campaign/$id/connect': typeof AuthenticatedCampaignIdConnectRoute
  '/campaign/$id/select-product': typeof AuthenticatedCampaignIdSelectProductRoute
  '/campaign/$id/tasks': typeof AuthenticatedCampaignIdTasksRoute
  '/campaign/$id/': typeof AuthenticatedCampaignIdIndexRoute
  '/settings/connect/': typeof AuthenticatedSettingsConnectIndexRoute
  '/campaign/$id/tasks/$taskId': typeof AuthenticatedCampaignIdTasksTaskIdRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicIndexRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/support': typeof AuthenticatedSupportRoute
  '/auth-success': typeof PublicAuthSuccessRoute
  '/settings/address': typeof AuthenticatedSettingsAddressRoute
  '/settings/email': typeof AuthenticatedSettingsEmailRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/invite/auth': typeof PublicInviteAuthRoute
  '/invite/email': typeof PublicInviteEmailRoute
  '/invite/otp': typeof PublicInviteOtpRoute
  '/oauth/callback': typeof PublicOauthCallbackRoute
  '/signin/email': typeof PublicSigninEmailRoute
  '/signin/otp': typeof PublicSigninOtpRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/invite': typeof PublicInviteIndexRoute
  '/campaign/$id/accepted': typeof AuthenticatedCampaignIdAcceptedRoute
  '/campaign/$id/address': typeof AuthenticatedCampaignIdAddressRoute
  '/campaign/$id/address-edit': typeof AuthenticatedCampaignIdAddressEditRoute
  '/campaign/$id/connect': typeof AuthenticatedCampaignIdConnectRoute
  '/campaign/$id/select-product': typeof AuthenticatedCampaignIdSelectProductRoute
  '/campaign/$id/tasks': typeof AuthenticatedCampaignIdTasksRoute
  '/campaign/$id': typeof AuthenticatedCampaignIdIndexRoute
  '/settings/connect': typeof AuthenticatedSettingsConnectIndexRoute
  '/campaign/$id/tasks/$taskId': typeof AuthenticatedCampaignIdTasksTaskIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/support': typeof AuthenticatedSupportRoute
  '/_public/auth-success': typeof PublicAuthSuccessRoute
  '/_public/invite': typeof PublicInviteRouteWithChildren
  '/_public/': typeof PublicIndexRoute
  '/_authenticated/campaign/$id': typeof AuthenticatedCampaignIdRouteWithChildren
  '/_authenticated/settings/address': typeof AuthenticatedSettingsAddressRoute
  '/_authenticated/settings/email': typeof AuthenticatedSettingsEmailRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_public/invite/auth': typeof PublicInviteAuthRoute
  '/_public/invite/email': typeof PublicInviteEmailRoute
  '/_public/invite/otp': typeof PublicInviteOtpRoute
  '/_public/oauth/callback': typeof PublicOauthCallbackRoute
  '/_public/signin/email': typeof PublicSigninEmailRoute
  '/_public/signin/otp': typeof PublicSigninOtpRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_public/invite/': typeof PublicInviteIndexRoute
  '/_authenticated/campaign/$id/accepted': typeof AuthenticatedCampaignIdAcceptedRoute
  '/_authenticated/campaign/$id/address': typeof AuthenticatedCampaignIdAddressRoute
  '/_authenticated/campaign/$id/address-edit': typeof AuthenticatedCampaignIdAddressEditRoute
  '/_authenticated/campaign/$id/connect': typeof AuthenticatedCampaignIdConnectRoute
  '/_authenticated/campaign/$id/select-product': typeof AuthenticatedCampaignIdSelectProductRoute
  '/_authenticated/campaign/$id/tasks': typeof AuthenticatedCampaignIdTasksRoute
  '/_authenticated/campaign/$id/': typeof AuthenticatedCampaignIdIndexRoute
  '/_authenticated/settings/connect/': typeof AuthenticatedSettingsConnectIndexRoute
  '/_authenticated/campaign/$id/tasks_/$taskId': typeof AuthenticatedCampaignIdTasksTaskIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/settings'
    | '/support'
    | '/auth-success'
    | '/invite'
    | '/campaign/$id'
    | '/settings/address'
    | '/settings/email'
    | '/settings/profile'
    | '/invite/auth'
    | '/invite/email'
    | '/invite/otp'
    | '/oauth/callback'
    | '/signin/email'
    | '/signin/otp'
    | '/settings/'
    | '/invite/'
    | '/campaign/$id/accepted'
    | '/campaign/$id/address'
    | '/campaign/$id/address-edit'
    | '/campaign/$id/connect'
    | '/campaign/$id/select-product'
    | '/campaign/$id/tasks'
    | '/campaign/$id/'
    | '/settings/connect/'
    | '/campaign/$id/tasks/$taskId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/support'
    | '/auth-success'
    | '/settings/address'
    | '/settings/email'
    | '/settings/profile'
    | '/invite/auth'
    | '/invite/email'
    | '/invite/otp'
    | '/oauth/callback'
    | '/signin/email'
    | '/signin/otp'
    | '/settings'
    | '/invite'
    | '/campaign/$id/accepted'
    | '/campaign/$id/address'
    | '/campaign/$id/address-edit'
    | '/campaign/$id/connect'
    | '/campaign/$id/select-product'
    | '/campaign/$id/tasks'
    | '/campaign/$id'
    | '/settings/connect'
    | '/campaign/$id/tasks/$taskId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/dashboard'
    | '/_authenticated/settings'
    | '/_authenticated/support'
    | '/_public/auth-success'
    | '/_public/invite'
    | '/_public/'
    | '/_authenticated/campaign/$id'
    | '/_authenticated/settings/address'
    | '/_authenticated/settings/email'
    | '/_authenticated/settings/profile'
    | '/_public/invite/auth'
    | '/_public/invite/email'
    | '/_public/invite/otp'
    | '/_public/oauth/callback'
    | '/_public/signin/email'
    | '/_public/signin/otp'
    | '/_authenticated/settings/'
    | '/_public/invite/'
    | '/_authenticated/campaign/$id/accepted'
    | '/_authenticated/campaign/$id/address'
    | '/_authenticated/campaign/$id/address-edit'
    | '/_authenticated/campaign/$id/connect'
    | '/_authenticated/campaign/$id/select-product'
    | '/_authenticated/campaign/$id/tasks'
    | '/_authenticated/campaign/$id/'
    | '/_authenticated/settings/connect/'
    | '/_authenticated/campaign/$id/tasks_/$taskId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/invite': {
      id: '/_public/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof PublicInviteRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth-success': {
      id: '/_public/auth-success'
      path: '/auth-success'
      fullPath: '/auth-success'
      preLoaderRoute: typeof PublicAuthSuccessRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/support': {
      id: '/_authenticated/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/invite/': {
      id: '/_public/invite/'
      path: '/'
      fullPath: '/invite/'
      preLoaderRoute: typeof PublicInviteIndexRouteImport
      parentRoute: typeof PublicInviteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_public/signin/otp': {
      id: '/_public/signin/otp'
      path: '/signin/otp'
      fullPath: '/signin/otp'
      preLoaderRoute: typeof PublicSigninOtpRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/signin/email': {
      id: '/_public/signin/email'
      path: '/signin/email'
      fullPath: '/signin/email'
      preLoaderRoute: typeof PublicSigninEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/oauth/callback': {
      id: '/_public/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/oauth/callback'
      preLoaderRoute: typeof PublicOauthCallbackRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/invite/otp': {
      id: '/_public/invite/otp'
      path: '/otp'
      fullPath: '/invite/otp'
      preLoaderRoute: typeof PublicInviteOtpRouteImport
      parentRoute: typeof PublicInviteRoute
    }
    '/_public/invite/email': {
      id: '/_public/invite/email'
      path: '/email'
      fullPath: '/invite/email'
      preLoaderRoute: typeof PublicInviteEmailRouteImport
      parentRoute: typeof PublicInviteRoute
    }
    '/_public/invite/auth': {
      id: '/_public/invite/auth'
      path: '/auth'
      fullPath: '/invite/auth'
      preLoaderRoute: typeof PublicInviteAuthRouteImport
      parentRoute: typeof PublicInviteRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/email': {
      id: '/_authenticated/settings/email'
      path: '/email'
      fullPath: '/settings/email'
      preLoaderRoute: typeof AuthenticatedSettingsEmailRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/address': {
      id: '/_authenticated/settings/address'
      path: '/address'
      fullPath: '/settings/address'
      preLoaderRoute: typeof AuthenticatedSettingsAddressRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/campaign/$id': {
      id: '/_authenticated/campaign/$id'
      path: '/campaign/$id'
      fullPath: '/campaign/$id'
      preLoaderRoute: typeof AuthenticatedCampaignIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/connect/': {
      id: '/_authenticated/settings/connect/'
      path: '/connect'
      fullPath: '/settings/connect/'
      preLoaderRoute: typeof AuthenticatedSettingsConnectIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/campaign/$id/': {
      id: '/_authenticated/campaign/$id/'
      path: '/'
      fullPath: '/campaign/$id/'
      preLoaderRoute: typeof AuthenticatedCampaignIdIndexRouteImport
      parentRoute: typeof AuthenticatedCampaignIdRoute
    }
    '/_authenticated/campaign/$id/tasks': {
      id: '/_authenticated/campaign/$id/tasks'
      path: '/tasks'
      fullPath: '/campaign/$id/tasks'
      preLoaderRoute: typeof AuthenticatedCampaignIdTasksRouteImport
      parentRoute: typeof AuthenticatedCampaignIdRoute
    }
    '/_authenticated/campaign/$id/select-product': {
      id: '/_authenticated/campaign/$id/select-product'
      path: '/select-product'
      fullPath: '/campaign/$id/select-product'
      preLoaderRoute: typeof AuthenticatedCampaignIdSelectProductRouteImport
      parentRoute: typeof AuthenticatedCampaignIdRoute
    }
    '/_authenticated/campaign/$id/connect': {
      id: '/_authenticated/campaign/$id/connect'
      path: '/connect'
      fullPath: '/campaign/$id/connect'
      preLoaderRoute: typeof AuthenticatedCampaignIdConnectRouteImport
      parentRoute: typeof AuthenticatedCampaignIdRoute
    }
    '/_authenticated/campaign/$id/address-edit': {
      id: '/_authenticated/campaign/$id/address-edit'
      path: '/address-edit'
      fullPath: '/campaign/$id/address-edit'
      preLoaderRoute: typeof AuthenticatedCampaignIdAddressEditRouteImport
      parentRoute: typeof AuthenticatedCampaignIdRoute
    }
    '/_authenticated/campaign/$id/address': {
      id: '/_authenticated/campaign/$id/address'
      path: '/address'
      fullPath: '/campaign/$id/address'
      preLoaderRoute: typeof AuthenticatedCampaignIdAddressRouteImport
      parentRoute: typeof AuthenticatedCampaignIdRoute
    }
    '/_authenticated/campaign/$id/accepted': {
      id: '/_authenticated/campaign/$id/accepted'
      path: '/accepted'
      fullPath: '/campaign/$id/accepted'
      preLoaderRoute: typeof AuthenticatedCampaignIdAcceptedRouteImport
      parentRoute: typeof AuthenticatedCampaignIdRoute
    }
    '/_authenticated/campaign/$id/tasks_/$taskId': {
      id: '/_authenticated/campaign/$id/tasks_/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/campaign/$id/tasks/$taskId'
      preLoaderRoute: typeof AuthenticatedCampaignIdTasksTaskIdRouteImport
      parentRoute: typeof AuthenticatedCampaignIdRoute
    }
  }
}

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsAddressRoute: typeof AuthenticatedSettingsAddressRoute
  AuthenticatedSettingsEmailRoute: typeof AuthenticatedSettingsEmailRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSettingsConnectIndexRoute: typeof AuthenticatedSettingsConnectIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAddressRoute: AuthenticatedSettingsAddressRoute,
  AuthenticatedSettingsEmailRoute: AuthenticatedSettingsEmailRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSettingsConnectIndexRoute:
    AuthenticatedSettingsConnectIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedCampaignIdRouteChildren {
  AuthenticatedCampaignIdAcceptedRoute: typeof AuthenticatedCampaignIdAcceptedRoute
  AuthenticatedCampaignIdAddressRoute: typeof AuthenticatedCampaignIdAddressRoute
  AuthenticatedCampaignIdAddressEditRoute: typeof AuthenticatedCampaignIdAddressEditRoute
  AuthenticatedCampaignIdConnectRoute: typeof AuthenticatedCampaignIdConnectRoute
  AuthenticatedCampaignIdSelectProductRoute: typeof AuthenticatedCampaignIdSelectProductRoute
  AuthenticatedCampaignIdTasksRoute: typeof AuthenticatedCampaignIdTasksRoute
  AuthenticatedCampaignIdIndexRoute: typeof AuthenticatedCampaignIdIndexRoute
  AuthenticatedCampaignIdTasksTaskIdRoute: typeof AuthenticatedCampaignIdTasksTaskIdRoute
}

const AuthenticatedCampaignIdRouteChildren: AuthenticatedCampaignIdRouteChildren =
  {
    AuthenticatedCampaignIdAcceptedRoute: AuthenticatedCampaignIdAcceptedRoute,
    AuthenticatedCampaignIdAddressRoute: AuthenticatedCampaignIdAddressRoute,
    AuthenticatedCampaignIdAddressEditRoute:
      AuthenticatedCampaignIdAddressEditRoute,
    AuthenticatedCampaignIdConnectRoute: AuthenticatedCampaignIdConnectRoute,
    AuthenticatedCampaignIdSelectProductRoute:
      AuthenticatedCampaignIdSelectProductRoute,
    AuthenticatedCampaignIdTasksRoute: AuthenticatedCampaignIdTasksRoute,
    AuthenticatedCampaignIdIndexRoute: AuthenticatedCampaignIdIndexRoute,
    AuthenticatedCampaignIdTasksTaskIdRoute:
      AuthenticatedCampaignIdTasksTaskIdRoute,
  }

const AuthenticatedCampaignIdRouteWithChildren =
  AuthenticatedCampaignIdRoute._addFileChildren(
    AuthenticatedCampaignIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedSupportRoute: typeof AuthenticatedSupportRoute
  AuthenticatedCampaignIdRoute: typeof AuthenticatedCampaignIdRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedSupportRoute: AuthenticatedSupportRoute,
  AuthenticatedCampaignIdRoute: AuthenticatedCampaignIdRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicInviteRouteChildren {
  PublicInviteAuthRoute: typeof PublicInviteAuthRoute
  PublicInviteEmailRoute: typeof PublicInviteEmailRoute
  PublicInviteOtpRoute: typeof PublicInviteOtpRoute
  PublicInviteIndexRoute: typeof PublicInviteIndexRoute
}

const PublicInviteRouteChildren: PublicInviteRouteChildren = {
  PublicInviteAuthRoute: PublicInviteAuthRoute,
  PublicInviteEmailRoute: PublicInviteEmailRoute,
  PublicInviteOtpRoute: PublicInviteOtpRoute,
  PublicInviteIndexRoute: PublicInviteIndexRoute,
}

const PublicInviteRouteWithChildren = PublicInviteRoute._addFileChildren(
  PublicInviteRouteChildren,
)

interface PublicRouteChildren {
  PublicAuthSuccessRoute: typeof PublicAuthSuccessRoute
  PublicInviteRoute: typeof PublicInviteRouteWithChildren
  PublicIndexRoute: typeof PublicIndexRoute
  PublicOauthCallbackRoute: typeof PublicOauthCallbackRoute
  PublicSigninEmailRoute: typeof PublicSigninEmailRoute
  PublicSigninOtpRoute: typeof PublicSigninOtpRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAuthSuccessRoute: PublicAuthSuccessRoute,
  PublicInviteRoute: PublicInviteRouteWithChildren,
  PublicIndexRoute: PublicIndexRoute,
  PublicOauthCallbackRoute: PublicOauthCallbackRoute,
  PublicSigninEmailRoute: PublicSigninEmailRoute,
  PublicSigninOtpRoute: PublicSigninOtpRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
